import React from "react";
import Sponsorship from "../../api/Sponsorship";
import SectionTitle from "../SectionTitle/SectionTitle";
import SponsorshipCard from "./SponsorshipCard";

const SponsorshipSection = () => {
  return (
    <section className="section-padding services-section-s3">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Sponsorship Opportunities"
              subtitle=""
              paragarap="Partner with the world's largest cash flow event and position your brand in front of 10,000+ business leaders and entrepreneurs."
              isLightBg={true}
            />
          </div>
        </div>
        <div className="services-wrap">
          <div
            className="row"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {Sponsorship.map((item, index) => (
              <div
                className="col col-xl-3 col-lg-6 col-md-6 col-12"
                key={index}
                style={{ display: "flex", marginBottom: "30px" }}
              >
                <SponsorshipCard
                  key={index}
                  title={item.title}
                  price={item.price}
                  description={item.description}
                  features={item.features}
                  isHighlighted={item.isHighlighted}
                  buttonBg={item.buttonBg}
                  buttonTextColor={item.buttonTextColor}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorshipSection;
